var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8.04C8.62 8.04 8.28 8.19 8.02 8.425L4.455 6.35C4.48 6.235 4.5 6.12 4.5 6C4.5 5.88 4.48 5.765 4.455 5.65L7.98 3.595C8.25 3.845 8.605 4 9 4C9.83 4 10.5 3.33 10.5 2.5C10.5 1.67 9.83 1 9 1C8.17 1 7.5 1.67 7.5 2.5C7.5 2.62 7.52 2.735 7.545 2.85L4.02 4.905C3.75 4.655 3.395 4.5 3 4.5C2.17 4.5 1.5 5.17 1.5 6C1.5 6.83 2.17 7.5 3 7.5C3.395 7.5 3.75 7.345 4.02 7.095L7.58 9.175C7.555 9.28 7.54 9.39 7.54 9.5C7.54 10.305 8.195 10.96 9 10.96C9.805 10.96 10.46 10.305 10.46 9.5C10.46 8.695 9.805 8.04 9 8.04Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
export default SvgShare;